export function getYouTubeVideoId(url: string): string | null {
  try {
    const u = new URL(url)
    if (u.hostname === 'youtu.be') return u.pathname.slice(1).split('?')[0] || null
    if (/(?:^|\.)youtube\.com$/.test(u.hostname)) return u.searchParams.get('v')
    return null
  } catch {
    return null
  }
}
